import { useNavigate } from "react-router-dom";
import egtrade_logo from "../../assets/EG_Trade_Logo.png";

interface EG_LogoType {
  isLeftNavExpanded?: boolean;
  width?: string;
  height?: string;
}
export const EG_Logo = (props: EG_LogoType) => {
  const { isLeftNavExpanded = true, width = "70px", height = "70px" } = props;
  const navigate = useNavigate();

  const logoStyle = {
    height: height,
    width: width,
    borderRadius: isLeftNavExpanded ? "15px" : "8px",
    transition: "all .2s",
    marginTop: "20px",
    cursor: "pointer",
  };
  return <img src={egtrade_logo} alt="EG-Trade-Logo" style={logoStyle} onClick={() => navigate("/")} />;
};
